import React from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {ThemeProvider} from "@material-ui/core/styles";
import {Button, Typography} from "@material-ui/core";
import Hairthentic from "../../components/svg/hairthentic";

const OurWorks = ({classes, headline}) => {
    return (
        <div className={`${classes.root3}`} id={"ourWork"}>
            <Grid container direction="row" justify="center" alignItems="center">
                <Grid container direction="column" justify="center" alignItems="center" item lg={6} xs={12}>
                    <Paper className={`${classes.paper1} `}>
                        <ThemeProvider theme={headline}>
                            <Typography variant={"h3"}
                                        data-aos="animation-left"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                Our Work
                            </Typography>
                            <Typography variant={"h6"} align={"justify"} paragraph={true}
                                        style={{margin: "5px", textIndent: "50px"}}
                                        data-aos="animation-left"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                In today’s competitive environment people are becoming progressively
                                obsessed over their looks to keep up social appearances, which are
                                increasingly fueled by social media use and the continuous efforts made to
                                move forward in careers, social circles etc.
                            </Typography>
                            <Typography variant={"h6"} align={"justify"} paragraph={true}
                                        style={{margin: "5px", textIndent: "50px"}}
                                        data-aos="animation-left"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                Hair can both promote confidence or shatter it based
                                on external feedback, making it an essential part of a
                                person’s social standing and prospects. Therefore, styling of hair,
                                which constitutes a significant portion of the appearance of a face,
                                has become increasingly important, and choosing the right hair cut/style has
                                become an increasingly vital component of maintaining an individual’s appearance.
                            </Typography>
                            <Typography variant={"h6"} align={"justify"} paragraph={true}
                                        style={{margin: "5px", textIndent: "50px"}}
                                        data-aos="animation-left"
                                // data-aos-offset="200"
                                // data-aos-delay="50"
                                        data-aos-duration="1000"
                            >
                                The main goal is to make it easier to find hairstyles that complement the faces.
                                Therefore, Hairthentic' s mobile application is implemented to solve the above
                                problem,
                                where the Team Codex has built a framework to classify users' face shape with the
                                use of machine learning.
                            </Typography>
                        </ThemeProvider>
                    </Paper>
                </Grid>
                <Grid container direction="column" justify="center" alignItems="center" item lg={6} xs={12}
                    // style={{margin: "0 20px"}}
                      data-aos="animation-right"
                    // data-aos-offset="200"
                    // data-aos-delay="50"
                      data-aos-duration="1000"
                >
                    <Paper className={`${classes.paper2} card`}>
                        <div className={`face front ${classes.ourWorkCardFront}`}>
                            {/*<MobileSvg/>*/}
                            <Hairthentic/>
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"}>
                                    Hairthentic
                                </Typography>
                            </ThemeProvider>
                        </div>
                        <div className={`face back ${classes.ourWorkCardBack}`}>
                            <ThemeProvider theme={headline}>
                                <Typography variant={"h4"} className={"text"} style={{color: "white"}}>
                                    Hairthentic
                                </Typography>
                                <div className={"text"}>

                                    <Typography variant={"h6"} align={"left"} className={"text"}
                                                style={{marginLeft: "20px", color: "white"}}>
                                        Features
                                    </Typography>

                                    <Typography variant={"h5"} className={"text"} align={"left"}
                                                style={{margin: "10px 0px 10px 40px",color: "white"}}>
                                        <i className="fa fa-hand-o-right" aria-hidden="true"/> Identify users face
                                        shapes.
                                    </Typography>
                                    <Typography variant={"h5"} className={"text"} align={"left"}
                                                style={{margin: "10px 0px 10px 40px",color: "white"}}>
                                        <i className="fa fa-hand-o-right" aria-hidden="true"/> Recommending
                                        celebrity
                                        hairstyles with same face shape.
                                    </Typography>
                                    <Typography variant={"h5"} className={"text"} align={"left"}
                                                style={{margin: "10px 0px 10px 40px",color: "white"}}>
                                        <i className="fa fa-hand-o-right" aria-hidden="true"/> Suggesting nearby
                                        salons
                                        to users.
                                    </Typography>

                                </div>
                            </ThemeProvider>
                            <Button color="inherit"
                                    className={`${classes.readMore} text`} target="_blank"
                                    href={"https://www.youtube.com/watch?v=HWZv_pENaMs"}><span>App Demo</span></Button>
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        </div>
    );
};

export default OurWorks;